import CopyConfirmationButton from "./copy-confirm-button";

export { CopyConfirmationButton };
